import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { AccountService } from 'src/app/core/services/account.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';

@Component({
  selector: 'app-activate-account',
  templateUrl: './activate-account.component.html',
  styleUrls: ['./activate-account.component.scss']
})
export class ActivateAccountComponent implements OnInit {
  token: string;
  @ViewChild('activationModal') activationModal: ModalComponent;
  constructor(
    private actRoute: ActivatedRoute,
    private accountService: AccountService,
    private router: Router,
  ) {
    this.token = this.actRoute.snapshot.params.token;
  }

  ngOnInit(): void {
    this.activateAccount();
  }

  activateAccount() {
    this.accountService.activateAccount(this.token).subscribe(
      () => {
        this.activationModal.body = "Your account has been activated. Please sign in to continue.";
        this.activationModal.open();
        this.router.navigate(['login']);
      },
      (error: HttpErrorResponse) => {
        if (error.status === 400) {
          const errorMessage = error.error as HttpErrorResponseMessages;
          errorMessage.reasons.forEach(reasons => {
            this.activationModal.body = reasons.errorMessage;
            this.activationModal.open();
          });
        }
        this.router.navigate(['login']);
      });
  }
}
